import { Injectable, signal } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { environment } from '../enviroments/enviroment';
import { SessionData } from '../models/session-data.interface';

@Injectable({ providedIn: 'root' })
export class SessionService {
  protected apiUrl = environment.apiUrl;
  private sessionStartedSignal = signal(false);
  public readonly sessionStarted = this.sessionStartedSignal.asReadonly();

  private sessionDataSignal = signal<SessionData | undefined>(undefined);
  public readonly sessionData = this.sessionDataSignal.asReadonly();
  public readonly sessionStarted$ = toObservable(this.sessionStarted);

  constructor(private http: HttpClient) {}

  startSession(): Observable<boolean> {
    const url = `${this.apiUrl}/start-session`;
    return this.http.put<{ session_id: string }>(url, {}).pipe(
      map((response) => {
        const uuid = response.session_id;
        this.sessionStartedSignal.set(true);
        this.sessionDataSignal.set({ uuid });
        return true;
      }),
      catchError(() => of(false)),
    );
  }

  public clearSession(): void {
    this.sessionStartedSignal.set(false);
    this.sessionDataSignal.set(undefined);
  }
}
